import PropTypes from 'prop-types';
import React from 'react';
import { confirmable } from 'react-confirm';

class Modal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};

    if (props.show) {
      document.body.classList.add('modal-open');
    } else {
      document.body.classList.remove('modal-open');
    }
  }

  static propTypes = {
    show: PropTypes.bool, // from confirmable. indicates if the dialog is shown or not.
    proceed: PropTypes.func, // from confirmable. call to close the dialog with promise resolved.
    cancel: PropTypes.func, // from confirmable. call to close the dialog with promise rejected.
    dismiss: PropTypes.func, // from confirmable. call to only close the dialog.
    confirmation: PropTypes.string, // arguments of your confirm function
    options: PropTypes.object, // arguments of your confirm function
  };

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.show) {
      document.body.classList.add('modal-open');
    } else {
      document.body.classList.remove('modal-open');
    }
  }

  render() {
    const { show, proceed, dismiss, cancel, confirmation, options } = this.props;

    return [
      <div
        key="modal"
        className={'modal fade ' + (show ? 'show' : '')}
        id="m_modal_1"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="exampleModalLabel"
        style={{ display: show ? 'block' : 'none' }}
      >
        <div className="modal-dialog" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLabel">
                {options.title}
              </h5>
              <button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={dismiss}>
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <div className="modal-body">
              <p>{confirmation}</p>
            </div>
            <div className="modal-footer">
              <button type="button" className="btn btn-secondary" data-dismiss="modal" onClick={cancel}>
                Cancel
              </button>
              <button
                type="button"
                className={'btn ' + (options.confirmStyle ? options.confirmStyle : 'btn-primary')}
                onClick={proceed}
              >
                {options.confirmText ? options.confirmText : 'Confirm'}
              </button>
            </div>
          </div>
        </div>
      </div>,
      <div key="backdrop" className={'modal-backdrop fade ' + (show ? 'show' : '')} />,
    ];
  }
}

// confirmable HOC pass props `show`, `dismiss`, `cancel` and `proceed` to your component.
export default confirmable(Modal);
